import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Modal } from '@mui/material';
import errorSign from '../../assets/images/errorSign.svg';
import './style.scss';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 340,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
};

const DeleteModal = ({ openDeleteModal, setOpenDeleteModal, handleDelete, deleteType }) => {
  const handleClose = () => setOpenDeleteModal(false);

  useEffect(() => {
      if (openDeleteModal) {
        const timeoutId = setTimeout(() => {
          const cancelButton = document.getElementById("cancel-button-id");
          if (cancelButton) {
            cancelButton.focus();
          }
        }, 100);
        return () => clearTimeout(timeoutId);
      }
    }, [openDeleteModal]);

  const confirmDelete = () => {
    handleDelete(deleteType || undefined);
    handleClose();
  };

  return (
    <div className="delte_modal_wrapper">
      <Modal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        className="delte_modal"
        aria-labelledby="Delete-modal-title-floor"
        aria-modal="true"
      >
        <div role="none">
          <Box sx={style} role="dialog"
            aria-labelledby="Delete-modal-title-floor">
            <div className="Modal_header">
              <h1 id="Delete-modal-title-floor">
                <img src={errorSign} alt="error" aria-hidden /> Delete
              </h1> 
            </div>
            <div className="Modal_middle">
              <div className="inputdrapper">
                <p>{`Are you sure you want to delete this ${deleteType ? 'device' : 'floor'}?`}</p>
              </div>
            </div>
            <div className="Modal_footer">
              <Box sx={{ display: 'flex' }}>
                <Button
                  variant="outlined"
                  className="cancelBtn"
                  id="cancel-button-id"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="saveBtn"
                  onClick={confirmDelete}
                >
                  Delete
                </Button>
              </Box>
            </div>
          </Box>
        </div>
      </Modal>
    </div>
  );
};

DeleteModal.propTypes = {
  openDeleteModal: PropTypes.bool.isRequired,
  setOpenDeleteModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  deleteType: PropTypes.string,
};

export default DeleteModal;
